import { createFileRoute } from '@tanstack/react-router'

import { PlatformInvoicingPage } from '../../../../../../components/pages/backoffice/platform/platform-contract-invoicing-page.tsx'
import { PermissionChecker } from '../../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/contracts/$subscriptionId/invoices/debug')({
  component: () => (
    <PermissionChecker requiredPermissions={['invoice.read']}>
      <PlatformInvoicingPage />
    </PermissionChecker>
  ),
})
